import React, { useState } from 'react';
import { FiChevronLeft } from 'react-icons/fi';
import { useLocation, useNavigate } from 'react-router-dom';
import DeliveryReport from './DeliveryReport';
import PreviewTemplateModal from './PreviewTemplateModal';
import Recipients from './Recipients';
import ReportsCampaignOverview from './ReportsCampaignOverview';

// Sample delivery data
const deliveryData = [
  {
    id: 1,
    recipient: 'Customer A',
    email: 'a@email.com',
    sent: '15-08-2025',
    status: 'Delivered',
  },
  {
    id: 2,
    recipient: 'Customer B',
    email: 'b@email.com',
    sent: '15-08-2025',
    status: 'Not Delivered',
  },
  {
    id: 3,
    recipient: 'Customer C',
    email: 'c@email.com',
    sent: '24-08-2025',
    status: 'Bounced',
  },
  {
    id: 4,
    recipient: 'Customer D',
    email: 'd@email.com',
    sent: '15-08-2025',
    status: 'Delivered',
  },
  {
    id: 5,
    recipient: 'Customer E',
    email: 'e@email.com',
    sent: '15-08-2025',
    status: 'Not Delivered',
  },
  {
    id: 6,
    recipient: 'Customer F',
    email: 'f@email.com',
    sent: '24-08-2025',
    status: 'Bounced',
  },
  {
    id: 7,
    recipient: 'Customer G',
    email: 'g@email.com',
    sent: '24-08-2025',
    status: 'Bounced',
  },
];

// Sample recipient data
const recipientData = [
  {
    id: 1,
    name: 'John Doe',
    dob: '18-11-1990',
    phone: '3434343',
    gender: 'male',
    postalCode: '343434',
    address: 'abc street, moscow, russia',
    email: 'example@email.com',
    segment: 'New User',
    tags: ['Political'],
    lastOpened: '15-08-2025',
    lastClicked: '15-08-2025',
    openRate: '80%',
    clickRate: '60%',
    emailsReceived: 100,
    emailsOpened: 80,
    emailsClicked: 60,
    lastActive: '15-08-2025',
    engagementScore: 82,
    unsubscribed: 'No',
  },
  {
    id: 2,
    name: 'Brad Pitt',
    dob: '18-11-1990',
    phone: '3434343',
    gender: 'male',
    postalCode: '343434',
    address: 'abc street, moscow, russia',
    email: 'example@email.com',
    segment: 'New User',
    tags: ['Sports'],
    lastOpened: '24-08-2025',
    lastClicked: '24-08-2025',
    openRate: '90%',
    clickRate: '70%',
    emailsReceived: 150,
    emailsOpened: 120,
    emailsClicked: 80,
    lastActive: '24-08-2025',
    engagementScore: 84,
    unsubscribed: 'No',
  },
  {
    id: 3,
    name: 'Robert Pattinson',
    dob: '18-11-1990',
    phone: '3434343',
    gender: 'male',
    postalCode: '343434',
    address: 'abc street, moscow, russia',
    email: 'example@email.com',
    segment: 'Old User',
    tags: ['Entertainment'],
    lastOpened: '24-08-2025',
    lastClicked: '24-08-2025',
    openRate: '85%',
    clickRate: '65%',
    emailsReceived: 120,
    emailsOpened: 90,
    emailsClicked: 60,
    lastActive: '24-08-2025',
    engagementScore: 90,
    unsubscribed: 'No',
  },
  {
    id: 4,
    name: 'Tom Cruise',
    dob: '18-11-1990',
    phone: '3434343',
    gender: 'male',
    postalCode: '343434',
    address: 'abc street, moscow, russia',
    email: 'example@email.com',
    segment: 'New User',
    tags: ['Political'],
    lastOpened: '15-08-2025',
    lastClicked: '15-08-2025',
    openRate: '80%',
    clickRate: '60%',
    emailsReceived: 100,
    emailsOpened: 80,
    emailsClicked: 60,
    lastActive: '15-08-2025',
    engagementScore: 67,
    unsubscribed: 'No',
  },
  {
    id: 5,
    name: 'Bruce Willis',
    dob: '18-11-1990',
    phone: '3434343',
    gender: 'male',
    postalCode: '343434',
    address: 'abc street, moscow, russia',
    email: 'example@email.com',
    segment: 'New User',
    tags: ['Sports'],
    lastOpened: '24-08-2025',
    lastClicked: '24-08-2025',
    openRate: '90%',
    clickRate: '70%',
    emailsReceived: 150,
    emailsOpened: 120,
    emailsClicked: 80,
    lastActive: '24-08-2025',
    engagementScore: 50,
    unsubscribed: 'No',
  },
  {
    id: 6,
    name: 'Mel Gibson',
    dob: '18-11-1990',
    phone: '3434343',
    gender: 'male',
    postalCode: '343434',
    address: 'abc street, moscow, russia',
    email: 'example@email.com',
    segment: 'Old User',
    tags: ['Entertainment'],
    lastOpened: '24-08-2025',
    lastClicked: '24-08-2025',
    openRate: '85%',
    clickRate: '65%',
    emailsReceived: 120,
    emailsOpened: 90,
    emailsClicked: 60,
    lastActive: '24-08-2025',
    engagementScore: 70,
    unsubscribed: 'No',
  },
  {
    id: 7,
    name: 'Arnold Schwarzenegar',
    dob: '18-11-1990',
    phone: '3434343',
    gender: 'male',
    postalCode: '343434',
    address: 'abc street, moscow, russia',
    email: 'example@email.com',
    segment: 'New User',
    tags: ['Political'],
    lastOpened: '15-08-2025',
    lastClicked: '15-08-2025',
    openRate: '80%',
    clickRate: '60%',
    emailsReceived: 100,
    emailsOpened: 80,
    emailsClicked: 60,
    lastActive: '15-08-2025',
    engagementScore: 60,
    unsubscribed: 'No',
  },
  {
    id: 8,
    name: 'Sylvestor Stallone',
    dob: '18-11-1990',
    phone: '3434343',
    gender: 'male',
    postalCode: '343434',
    address: 'abc street, moscow, russia',
    email: 'example@email.com',
    segment: 'New User',
    tags: ['Sports'],
    lastOpened: '24-08-2025',
    lastClicked: '24-08-2025',
    openRate: '90%',
    clickRate: '70%',
    emailsReceived: 150,
    emailsOpened: 120,
    emailsClicked: 80,
    lastActive: '24-08-2025',
    engagementScore: 85,
    unsubscribed: 'No',
  },
  {
    id: 9,
    name: 'Jackie Chan',
    dob: '18-11-1990',
    phone: '3434343',
    gender: 'male',
    postalCode: '343434',
    address: 'abc street, moscow, russia',
    email: 'example@email.com',
    segment: 'Old User',
    tags: ['Entertainment'],
    lastOpened: '24-08-2025',
    lastClicked: '24-08-2025',
    openRate: '85%',
    clickRate: '65%',
    emailsReceived: 120,
    emailsOpened: 90,
    emailsClicked: 60,
    lastActive: '24-08-2025',
    engagementScore: 69,
    unsubscribed: 'No',
  },
];

const FiChevronLeftComponent = FiChevronLeft as unknown as React.ComponentType<{
  size?: number | string;
  className?: string;
}>;

// const FiMailComponent = FiMail as unknown as React.ComponentType<{
//   size?: number | string;
//   className?: string;
// }>;

// Renders a stat box for campaign metrics
// const StatBox: React.FC<{ label: string; value: string | number }> = ({
//   label,
//   value,
// }) =>
//   label !== 'New Subscribers' &&
//     label !== 'Unsubscribes' &&
//     label !== 'Last Opened' &&
//     label !== 'Last Clicked' ? (
//     <div className='bg-white rounded-md p-3 flex items-center justify-between border border-gray-200 shadow-sm'>
//       <div>
//         <h3 className='text-[#657584] text-[14px] mb-2 font-semibold'>
//           {label}
//         </h3>
//         <p className='text-[28px] text-[#3F5265] font-semibold'>{value}</p>
//       </div>
//       <div>
//         <span className='flex items-center justify-center mr-2 w-[30px] h-[30px] rounded-[5px] bg-[#FFF1EC]'>
//           <FiMailComponent className='text-orange-500 text-2xl' size={17} />
//         </span>
//       </div>
//     </div>
//   ) : (
//     <div
//       className={`bg-white ${label === 'New Subscribers' ? 'rounded-t' : 'rounded-b'
//         } p-[13.5px] flex items-center justify-between border border-gray-200 shadow-sm`}
//     >
//       <div className='flex justify-between items-center w-[100%]'>
//         <h3 className='text-[#18181B] text-[14px] font-semibold'>{label}</h3>
//         <p className='text-[20px] text-[#3F5265] font-semibold'>{value}</p>
//       </div>
//     </div>
//   );

const ReportsViewCampaign: React.FC = () => {
  const navigate = useNavigate();
  const { state: campaign } = useLocation();
  // State for managing the active tab (overview, delivery, recipients)
  const [activeTab, setActiveTab] = useState<
    'overview' | 'delivery' | 'recipients'
  >('overview');
  // State for toggling the preview email modal
  const [isModalOpen, setIsModalOpen] = useState(false);
  // State for filtering engagement chart data (24 hours or 7 days)
  // const [filter, setFilter] = useState<'24h' | '7d'>('24h');

  // Handle missing campaign data
  if (!campaign) {
    return <div className='p-6'>No campaign data</div>;
  }

  // Generates engagement data for the last 24 hours
  // const engagementData24h = Array.from({ length: 24 }, (_, i) => ({
  //   hour: `${i.toString().padStart(2, '0')}:00`,
  //   open: Math.floor(campaign.stats?.opened / 24 + Math.random() * 10),
  //   click: Math.floor(campaign.stats?.clicked / 24 + Math.random() * 5),
  // }));

  // Generates engagement data for the last 7 days
  // const days = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];
  // const engagementData7d = days.map((day) => ({
  //   day,
  //   open: Math.floor(campaign.stats?.opened / 7 + Math.random() * 20),
  //   click: Math.floor(campaign.stats?.clicked / 7 + Math.random() * 10),
  // }));

  // Selects engagement data based on filter
  // const engagementData =
  //   filter === '24h' ? engagementData24h : engagementData7d;

  // Configures chart series for ApexCharts
  // const series =
  //   filter === '24h'
  //     ? [
  //       { name: 'Open', data: engagementData.map((d) => d.open) },
  //       { name: 'Click', data: engagementData.map((d) => d.click) },
  //     ]
  //     : [
  //       { name: 'Open', data: engagementData.map((d) => d.open) },
  //       { name: 'Click', data: engagementData.map((d) => d.click) },
  //     ];

  // Configures chart options for ApexCharts
  // const options: ApexCharts.ApexOptions = {
  //   chart: { type: 'line', toolbar: { show: false } },
  //   stroke: { curve: 'smooth', width: 3 },
  //   xaxis: {
  //     categories: engagementData.map((d) =>
  //       filter === '24h'
  //         ? (d as { hour: string }).hour
  //         : (d as { day: string }).day
  //     ),
  //     labels: { style: { fontSize: '12px', colors: '#657584' } },
  //   },
  //   yaxis: { labels: { style: { fontSize: '12px', colors: '#657584' } } },
  //   colors: ['#FF5733', '#008FFB'],
  //   legend: { position: 'top', horizontalAlign: 'left' },
  //   markers: { size: 4 },
  //   grid: { borderColor: '#f1f1f1' },
  // };

  // Handles tab switching between Overview, Delivery Report, and Recipients
  const handleTabSwitch = (tab: 'overview' | 'delivery' | 'recipients') => {
    setActiveTab(tab);
  };

  // Toggles the visibility of the email preview modal
  const toggleModal = () => {
    setIsModalOpen((prev) => !prev);
  };

  return (
    <div className='p-2'>
      {/* Back Button */}
      <button
        onClick={() => navigate(-1)}
        className='flex items-center text-sm text-teal-600 mb-4 hover:underline font-semibold'
        style={{ color: '#00899E', fontSize: '14px' }}
      >
        <FiChevronLeftComponent className='mr-1' /> Back to Reports
      </button>

      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <div>
          <h2 className='text-[20px] font-bold text-[#3F5265]'>
            View Campaign
          </h2>
          <p className='text-[#657584] mb-6 text-[16px]'>
            Campaign performance and analytics
          </p>
        </div>
      </div>

      {/* Campaign Header */}
      <div className='bg-white p-4 rounded-lg mb-6 border border-gray-200 shadow-sm'>
        <div className='flex justify-between items-start'>
          <div>
            <h2 className='text-xl font-semibold text-[#1F2937] text-[18px]'>
              {campaign.name}
            </h2>
            <p className='text-gray-500'>{campaign.subtitle}</p>
          </div>
          <button
            onClick={toggleModal}
            className='text-[#FF7A59] px-3 py-2 rounded hover:bg-orange-50 text-sm border border-[#FF7A59] text-[14px]'
          >
            Preview Email
          </button>
        </div>

        <div className='flex flex-wrap gap-2 mt-5 text-sm text-gray-600 bg-[#F5F8FA] p-3 rounded justify-between'>
          <span className='text-[#9FA9B2] text-[12px]'>
            SEGMENT{' '}
            <span className='text-[#263445] text-[16px] ml-2'>
              {campaign.segment}
            </span>
          </span>
          <span className='text-[#9FA9B2] text-[12px]'>
            TAGS{' '}
            <span className='text-[#263445] text-[16px] ml-2'>
              {campaign.tags.join(', ')}
            </span>
          </span>
          <span className='text-[#9FA9B2] text-[12px]'>
            DELIVERED{' '}
            <span className='text-[#263445] text-[16px] ml-2'>
              {campaign.deliveredDate}
            </span>
          </span>
        </div>
      </div>

      {/* Tabs */}
      <div className='flex gap-6 mt-2'>
        <button
          onClick={() => handleTabSwitch('overview')}
          className={`pb-2 ${activeTab === 'overview'
            ? 'border-b-2 border-[#00899E] text-[#00899E] font-semibold'
            : 'text-gray-500'
            }`}
        >
          Overview
        </button>
        <button
          onClick={() => handleTabSwitch('delivery')}
          className={`pb-2 ${activeTab === 'delivery'
            ? 'border-b-2 border-[#00899E] text-[#00899E] font-semibold'
            : 'text-gray-500'
            }`}
        >
          Delivery Report
        </button>
        <button
          onClick={() => handleTabSwitch('recipients')}
          className={`pb-2 ${activeTab === 'recipients'
            ? 'border-b-2 border-[#00899E] text-[#00899E] font-semibold'
            : 'text-gray-500'
            }`}
        >
          Recipients
        </button>
      </div>

      <div className={activeTab === 'overview' ? 'py-6' : ''}>
        {/* Tab Content */}
        {activeTab === 'overview' && (
          <ReportsCampaignOverview campaign={campaign} />
        )}
        {activeTab === 'delivery' && (
          <DeliveryReport deliveryData={deliveryData} />
        )}
        {activeTab === 'recipients' && (
          <Recipients
            recipients={recipientData}
            c={campaign?.id}
            fromtab='campaigns'
          />
        )}
      </div>
      {/* Modal Component */}
      <PreviewTemplateModal isOpen={isModalOpen} onClose={toggleModal} />
    </div>
  );
};

// Export the ReportsViewCampaign component as the default export
export default ReportsViewCampaign;
